<template>
  <div id="profileimg">
    <h4 class="text-bold"><i class="fa fa-camera"></i> Change Profile Image</h4>
    <div class="box-func">
      <div class="box-body">
        <div class="clearfix"></div>
        <div class="row">
          <div class="col-md-2 col-md-offset-1 col-sm-12 text-center">
            <img v-if="filepath !== ''" :src="filepath" class="img-employee img-circle" style="height: 150px; width: 150px; padding: 10px; color: black;">
            <img v-if="filepath === ''" src="static/images/employee/no_image.png" class="img-employee img-circle" style="height: 150px; width: 150px; padding: 10px; color: black;">
          </div>
          <div class="col-md-6 col-md-offset-1 col-sm-12">
            <hrms-dropzone  :prefixFileName="codempid"
                            ref="hrmsDropzone"
                            :flgToggle="toggle"
                            :flgRename="true"
                            :maxFileSizeInMB="5"
                            resizeMethod="crop"
                            resizeWidth="150"
                            resizeHeight="150"
                            acceptedFileTypes="image/*"
                            :flgPreview="true" />
          </div>
        </div>

        <div class="box-footer clear-padding" style="padding-top: 10px !important; margin-top: 10px !important">
          <div class="col-xs-12 text-center clear-padding">
            <button type="button" class="btn bg-color-skin" @click="callSave()" ><i class="fa fa-check-circle"></i>{{ app.button[app.nowLang]['save'] }}</button>
            <button type="button" class="btn bg-dark-gray" @click="resetDropzone(false)" ><i class="fa fa-refresh"></i>{{ app.button[app.nowLang]['clear'] }}</button>
          </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapMutations, mapActions } from 'vuex'
import * as types from 'store/modules/profileimg/mutation-types'

export default {
  name: 'profileimg',
  data () {
    return {
      app: this.$root.$children[0],
      dash: this.$root.$children[0].$children[0]
    }
  },
  created () {},
  computed: {
    codempid () {
      let currentUser = this.app.currentUser
      return currentUser.p_codempid
    },
    toggle () {
      return this.flgToggle
    },
    ...mapGetters({
      filepath: types.GET_PROFILEIMG_FILEPATH,
      flgToggle: types.GET_PROFILEIMG_TOGGLE
    }),
    getTfolder () {
      let tfolder = this.dash.getTfolder()
      return tfolder
    }
  },
  watch: {
    getTfolder () {
      this.receivedProfileimgFilepath(this.getTfolder)
    }
  },
  methods: {
    callSave () {
      let filepath = this.$refs.hrmsDropzone.inputFileName
      if (filepath !== '') {
        this.postProfileimgSave({ getTfolder: this.getTfolder, filename: filepath })
      }
    },
    resetDropzone (status) {
      this.toggleDropzone(status)
      this.receivedProfileimgFilepath(this.getTfolder)
    },
    ...mapMutations({
      toggleDropzone: types.SET_PROFILEIMG_TOGGLE
    }),
    ...mapActions({
      receivedProfileimgFilepath: types.RECEIVED_PROFILEIMG_FILEPATH,
      postProfileimgSave: types.POST_PROFILEIMG_SAVE
    })
  }
}
</script>



// WEBPACK FOOTER //
// component.vue?227dcb5a